/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { QueryExpression } from '../models/query-expression';
import { SortDirection } from '../models/sort-direction';
export interface Query {
  expressions?: Array<QueryExpression> | null;
  sortBy?: string | null;
  sortDirection?: SortDirection;
}

export class Query {
  expressions?: QueryExpression[] | null;
  sortBy?: string | null;
  sortDirection?: SortDirection;

  constructor(value: Query) {
    this.expressions = value?.expressions?.map((x) => new QueryExpression(x));
    this.sortBy = value?.sortBy;
    this.sortDirection = value?.sortDirection ? Object.entries(Object.values(SortDirection)).flatMap((x) => x).find(x => x === value.sortDirection) as SortDirection : undefined;
  }
}
